export interface NumberRangeValue {
  min: number;
  max: number;
}

export function isNumberRangeType(range: unknown): range is NumberRangeValue {
  return (
    typeof range === "object" &&
    range != null &&
    "min" in range &&
    range.min != null &&
    range.min !== "" &&
    "max" in range &&
    range.max != null &&
    range.max !== ""
  );
}
